import React, { ForwardRefRenderFunction, forwardRef } from "react";

import OverviewGridItem from "../../../components/Overview/GridItem";
import { SupplyChainOverviewConfigure } from "../../../models/supply.chain.overview.configure";

interface Props {
  panel: keyof SupplyChainOverviewConfigure;
  widget: string;
  [property: string]: any;
}

const GridItemContainer: ForwardRefRenderFunction<HTMLDivElement, Props> = (props, ref) => {
  const { children, panel, widget, ...rest } = props;

  return (
    <OverviewGridItem panel={panel} ref={ref} widget={widget} {...rest}>
      {children}
    </OverviewGridItem>
  );
};

export default forwardRef(GridItemContainer);
